/**
 * 垂直填充动画
 */
import fvAnimation from "./fvAnimation"
export default class fvVerticalFill extends fvAnimation {
    constructor(shape){
        super(shape,"fvVerticalFill");
        this.sizeFunction = AsyncFunction("return " + this.expression);
        this.realMin = AsyncFunction("return " + this.realMin);
        this.realMax = AsyncFunction("return " + this.realMax);
        this.getData();
    }

    async getData(){
        this.size = await this.executionScript(this.sizeFunction);
        this.realMinValue = await this.executionScript(this.realMin);
        this.realMaxValue = await this.executionScript(this.realMax);
    }

    async run(canvas,value){
        //if(value == false) return;
        this.getData();
    }

    runEnd(canvas){
        if(this.size == -9999 || this.size == undefined){
            this.size = 0;
        }
        if(this.size >= this.realMaxValue){
            this.size = this.realMaxValue;
        }
        if(this.size <= this.realMinValue){
            this.size = this.realMinValue;
        }
        var param1 = parseFloat(this.viewMax) - parseFloat(this.viewMin);
        var param2 = this.size - parseFloat(this.realMinValue);
        var param3 = parseFloat(this.realMaxValue) - parseFloat(this.realMinValue);
        var viewNum = param1 * param2 / param3 + parseFloat(this.viewMin);
        canvas.fillStyle = this.fillcolor;
        var rect = {
            x : 0,
            y : 0,
            w : 0,
            h : 0
        }
        if(this.shape.fctype == "fvRectObj"){
            switch(this.beginPath){
                case "down" :
                    rect = {
                        x : this.shape.cx + this.shape.borderWidth / 2,
                        y : this.shape.cy + this.shape.regionHeight + this.shape.borderWidth / 2,
                        w : this.shape.regionWidth,
                        h : -(viewNum/100)*parseFloat(this.shape.regionHeight)
                    }
                break;
                case "up" :
                    rect = {
                        x : this.shape.cx + this.shape.borderWidth / 2,
                        y : this.shape.cy + viewNum/100*this.shape.regionHeight + this.shape.borderWidth / 2,
                        w : this.shape.regionWidth,
                        h : -(viewNum/100)*parseFloat(this.shape.regionHeight)
                    }
                break; 
            }
            canvas.fillRect(rect.x,rect.y,rect.w,rect.h); 
        }else if(this.shape.fctype=="fvEllipseObj"){
            canvas.save();
            canvas.clip();
            this.shape.x = (this.shape.originalSize.x * this.shape.magnification.x);
            this.shape.y = (this.shape.originalSize.y * this.shape.magnification.y);
            this.shape.width = (this.shape.originalSize.width * this.shape.magnification.x);
            this.shape.height = (this.shape.originalSize.height * this.shape.magnification.y);
            this.shape.borderWidth = (this.shape.originalSize.borderWidth * this.shape.magnification.x);
            let aa = this.shape.width/2
            let b =1.5;
            if(this.shape.width<this.shape.height){
                aa = this.shape.height/2
                b =3;
            }
            switch(this.beginPath){
                case "down" :
                    rect = {
                        x : this.shape.centerX-aa,
                        y : this.shape.centerY+(aa),
                        w : (this.shape.width + this.shape.borderWidth)*b,
                        h : -(viewNum/100)*parseFloat(this.shape.height)
                    }
                break;
                case "up" :
                    rect = {
                        x : this.shape.centerX-aa,
                        y : this.shape.centerY-aa,
                        w : (this.shape.regionWidth)*b,
                        h : viewNum/100*parseFloat(this.shape.regionHeight)
                    }
                break; 
            }
            canvas.fillRect(rect.x,rect.y,rect.w,rect.h); 
            canvas.restore();
        }else{
            canvas.save();
            canvas.clip();
            switch(this.beginPath){
                case "down" :
                    rect = {
                        x : this.shape.cx,
                        y : this.shape.cy + this.shape.height,
                        w : this.shape.width + this.shape.borderWidth,
                        h : -(viewNum/100)*parseFloat(this.shape.height)
                    }
                break;
                case "up" :
                    rect = {
                        x : this.shape.cx,
                        y : this.shape.cy,
                        w : this.shape.regionWidth,
                        h : viewNum/100*parseFloat(this.shape.regionHeight)
                    }
                break; 
            }
            canvas.fillRect(rect.x,rect.y,rect.w,rect.h); 
            canvas.restore();
        }  
        
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvVerticalFill.js